const DEFAULT_TEST_API_URL = 'https://localhost:3000/'

// TODO: change to envs when set up
const envConfig = (() => {
  const obj = {
    urls: {
      api: '',
    },
    keys: {
      pk: process.env.NX_PUBLIC_NOMINATION_FORM_PK,
    },
  }

  const { NX_PUBLIC_API_URL, NX_TEST_MODE } = process.env

  obj.urls.api =
    NX_TEST_MODE === 'true' ? `${DEFAULT_TEST_API_URL}` : `${NX_PUBLIC_API_URL}`

  return obj
})()

export const config = {
  ...envConfig,
  version: '1.0.0',
}
